import { createStore, compose, applyMiddleware, Store, Action } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore, persistReducer } from 'redux-persist';
import { Persistor } from 'redux-persist/es/types';
import storage from 'redux-persist/lib/storage';
import { PersistPartial } from 'redux-persist/es/persistReducer';

import config from 'config';

import middleware, { sagaMiddleware } from './middleware';
import rootReducer from './reducers';
import rootSaga from './sagas';
import * as Types from './types';

export default (initialState: Partial<Types.IState> = {}): { store: Store<Types.IState>, persist: Persistor } => {
  const composeEnhancer = process.env.NODE_ENV === 'development' ? composeWithDevTools({}) : compose;

  Object.keys(localStorage).forEach((key) => {
    const matches = key.match(/persist:version-(.*)/);
    if (!matches || matches.length < 2) {
      return;
    }
    const version = matches[1];
    if (version !== config.app.version) {
      localStorage.removeItem(key);
    }
  });

  const persistConfig = {
    key: `version-${config.app.version}`,
    storage,
    whitelist: ['act', 'application', 'certificate']
  };
  const persistedReducer = persistReducer<Types.IState>(persistConfig, rootReducer);
  const store: Store<Types.IState> = createStore<Types.IState & PersistPartial, Action<any>, unknown, unknown>(
    persistedReducer, composeEnhancer(applyMiddleware(...middleware))
  );
  const persist = persistStore(store);

  sagaMiddleware.run(rootSaga);

  /* istanbul ignore next */
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(require('./reducers'));
    });
  }

  return { store, persist };
};